import { defineMessages } from 'react-intl';

export default defineMessages({
	helpcenterDetailsItem: {
		defaultMessage: 'Details',
		description:
			'Label for the help center details item in the help center management screen sidebar',
		id: 'admin.management.sidebar.edit.details',
	},
	helpcenterManageProjectsItem: {
		defaultMessage: 'Projects',
		description:
			'Label for the help center projects item in the help center management screen sidebar',
		id: 'admin.management.sidebar.manage.projects',
	},
	helpcenterManageProjectsItemGalaxia: {
		defaultMessage: 'Spaces',
		description:
			'Label for the help center spaces item in the help center management screen sidebar',
		id: 'admin.management.sidebar.manage.projects-galaxia',
	},
	helpcenterManagePagesItem: {
		defaultMessage: 'Landing pages',
		description:
			'Label for the help center landing pages item in the help center management screen sidebar',
		id: 'admin.management.sidebar.landing.pages',
	},
	helpcenterRovoServiceAgentItem: {
		defaultMessage: 'Rovo agent',
		description:
			'Label for the help center Rovo service agent item in the help center management screen sidebar',
		id: 'admin.management.sidebar.rovo.service.agent',
	},
	helpcenterVsaReportingItem: {
		defaultMessage: 'Virtual service agent',
		description:
			'Label for the help center reporting item in the help center management screen sidebar',
		id: 'admin.management.sidebar.reporting',
	},
	errorTitle: {
		defaultMessage: 'Something went wrong',
		description: 'Error title',
		id: 'admin.management.sidebar.error.title',
	},
	errorDescription: {
		defaultMessage: 'Refresh the page and try again',
		description: 'Error description',
		id: 'admin.management.sidebar.error.description',
	},
	landingPagesSidebarChangeBoardingHeading: {
		defaultMessage: 'Create unique pages in the help center',
		description:
			'Heading text for Landing Pages Change Boarding from Help Center Management screen sidebar',
		id: 'admin.management.sidebar.landing.pages.changeboarding.heading',
	},
	landingPagesSidebarChangeBoardingContent: {
		defaultMessage:
			"Customize layouts and curate help content to create visually-appealing landing pages that meet your audience's needs.",
		description:
			'Spotlight content text for Landing Pages Change Boarding from Help Center Management screen sidebar',
		id: 'admin.management.sidebar.landing.pages.changeboarding.content',
	},
	landingPagesSidebarChangeBoardingDismissButton: {
		defaultMessage: 'Dismiss',
		description:
			'Dismiss button text for Landing Pages Change Boarding from Help Center Management screen sidebar',
		id: 'admin.management.sidebar.landing.pages.changeboarding.button.dismiss',
	},
	landingPagesSidebarChangeBoardingTryButton: {
		defaultMessage: 'Try now',
		description:
			'Try now button text for Landing Pages Change Boarding from Help Center Management screen sidebar',
		id: 'admin.management.sidebar.landing.pages.changeboarding.button.try',
	},
});
